var _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _circle6, _ellipse2, _circle7, _circle8, _circle9, _ellipse3, _ellipse4, _ellipse5, _ellipse6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSect2RadialPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 137,
    viewBox: "0 0 279 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 32.5,
    r: 190.5,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 32.5005,
    r: 176.692,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 32.4984,
    r: 160.838,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.372,
    cy: 32.372,
    r: 145.368,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.372,
    cy: 32.3714,
    r: 133.606,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.372,
    cy: 30.0694,
    rx: 109.569,
    ry: 109.569,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 30.2005,
    r: 97.9349,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.5,
    cy: 30.2004,
    rx: 85.1497,
    ry: 85.1497,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 32.5014,
    r: 75.1772,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.372,
    cy: 32.3705,
    r: 60.7299,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.263,
    cy: 30.3258,
    r: 47.9938,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.5,
    cy: 32.2593,
    rx: 39.021,
    ry: 39.021,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.5,
    cy: 30.318,
    rx: 28.5993,
    ry: 28.5992,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.258,
    cy: 30.3188,
    rx: 19.147,
    ry: 19.1469,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.258,
    cy: 30.0766,
    rx: 8.48283,
    ry: 8.48282,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSect2RadialPattern);
export default __webpack_public_path__ + "static/media/sect2-radial-pattern.88d0ecf0db10ab833407f80ceafdd10c.svg";
export { ForwardRef as ReactComponent };